import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../../../../auth';
import Swal from 'sweetalert2';
import { Button, Col, Form, Modal, Row, Spinner, Table } from 'react-bootstrap';
import { Formik } from 'formik';
import { FaWindowClose } from 'react-icons/fa';
import Select from 'react-select';
import { axiosAuth } from '../../../../../api';

function ModalUbahDivisi({
    rowSelected,
    showEditDivisi,
    setShowEditDivisi,
    retrieveDivisi,
    accessToken
}) {

    const { theme } = useContext(ThemeContext);
    const [disabled, setDisabled] = useState(false);
    const [listMenuDefault, setListMenuDefault] = useState([]);
    const [listMenu, setListMenu] = useState([]);
    const [selectedMenu, setSelectedMenu] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const retrieveMenuDefault = () => {
        axiosAuth.get(`/api/menus?groupId=${rowSelected?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setListMenuDefault(res.data.data);

            }).catch(err => {

                console.error(err)
            })
    };

    const retrieveMenu = () => {
        axiosAuth.get(`/api/menus`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setListMenu(res.data.data);

            }).catch(err => {

                console.error(err)
            })
    };

    useEffect(() => {
        if (rowSelected?.id !== undefined) retrieveMenuDefault();
        if (accessToken !== undefined) retrieveMenu();
    }, [rowSelected?.id, accessToken]);

    const defaultValue = {
        groupName: rowSelected?.groupName || "",
    };

    const handleDelete = async (rowId) => {
        const result = await Swal.fire({
            title: 'Apakah anda yakin ingin menghapus menu ini?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya, hapus menu ini!',
            cancelButtonText: 'Batalkan',
        });

        if (result.isConfirmed) {

            try {
                const response = await axiosAuth.delete(`/api/menus?groupId=${rowSelected?.id}&menuId=${rowId}`,
                    {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            withCredentials: true,
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );

                Swal.fire('Berhasil!', 'Menu berhasil dihapus', 'success');
                retrieveMenuDefault();
            } catch (err) {
                console.error(err);
                Swal.fire('Error', 'Terjadi kesalahan saat menghapus menu!', 'error');
            }
        } else {
            <></>
        }
    };


    const menuOptions = listMenu.map(menu => ({
        value: menu.id,
        label: menu.menuName,
    }));

    const handleSelectMenu = selectedOption => {
        setSelectedMenu(selectedOption);
    };

    const handleSubmitEdit = async (values) => {

        const finalData = { ...values, };
        setIsSubmitting(true);
        setDisabled(true);

        try {

            const response = await axiosAuth.put(`/api/groups/${rowSelected?.id}`, finalData, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleClose();
            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengubah Divisi',
                showConfirmButton: true,
            });
            retrieveDivisi();
            retrieveMenuDefault();
            retrieveMenu();
            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {

            console.error(err);
            handleClose();
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat mengubah Divisi',
            });
            setIsSubmitting(false);
            setDisabled(false);

        } finally {
            setIsSubmitting(false);
            setDisabled(false);
        }
    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
        },
    };

    const selectStyles = {
        control: (provided, state) => ({
            ...provided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            fontFamily: 'Poppins-Regular'
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: theme === 'light' ? (state.isFocused ? 'red' : 'white') : (state.isFocused ? 'red' : '#222'),
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : '#fff',
            fontFamily: 'Poppins-Regular'
        }),
    };

    const [showSelect, setShowSelect] = useState(false);

    const handleShowTambahMenu = () => {
        setShowSelect(!showSelect);
    };

    const handleClose = () => {
        setShowEditDivisi(false);
        setSelectedMenu([]);
        setShowSelect(false);
    };

    return (
        <Modal
            show={showEditDivisi}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
            centered
            data-bs-theme={theme === 'light' ? 'dark' : ''}
        >
            <Modal.Header closeButton >
                <Modal.Title style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222222' }}>
                    Ubah Divisi
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    initialValues={defaultValue}
                    enableReinitialize={true}
                    onSubmit={handleSubmitEdit}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <Form.Group className="mb-3">
                                <Form.Label style={formStyles.label} htmlFor='divisi'>Nama Divisi*</Form.Label>
                                <Form.Control
                                    id='divisi'
                                    type="text"
                                    value={values.groupName}
                                    onChange={handleChange("groupName")}
                                    required
                                    style={formStyles.input}
                                />
                            </Form.Group>
                            <div className="d-grid gap-2 mt-4">
                                {isSubmitting ? (
                                    <Button
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled
                                    >
                                        <Spinner
                                            animation="border"
                                            size='sm'
                                        />
                                    </Button>
                                ) : (
                                    <Button
                                        type="submit"
                                        id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                        variant='btn'
                                        disabled={disabled}
                                    >
                                        Simpan
                                    </Button>
                                )}
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default ModalUbahDivisi
